import teacherService from 'ApiService/Admin/teacherService';
import { AuthContext } from 'contexts/AuthContext';
import GenericUserList from 'pages/List/GenericUserList';
import { useContext, useState } from 'react';
import TeacherDetailModal from './Model/TeacherDetailModal';

const TeacherList = () => {
  const { state } = useContext(AuthContext);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [selectedTeacherId, setSelectedTeacherId] = useState(null);

  const selectedBranch = state?.selectedBranch;
  const userRole = state?.user?.role;
  const columns = [
    { header: 'Teacher Name', key: 'name' },
    { header: 'Email', key: 'email' },
    // { header: 'Gender', key: 'gender' },
    // { header: 'Date of Birth', key: 'dob' },
    // { header: 'Institute ID', key: 'instituteId' },
    ...(userRole === 'superadmin'
      ? [
          { header: 'Branch', key: 'branchName' },
          { header: 'Location', key: 'branchLocation' },
        ]
      : []),
    { header: 'Contact No', key: 'contact' },
    { header: 'Department', key: 'departmentName' },
  ];

  const fetchTeachers = async (userId) => {
    return await teacherService.getAllTeacher(userId, selectedBranch);
  };

  const updateTeacher = async (teacherData) => {
    return await teacherService.updateTeacher(teacherData);
  };

  const handleView = (teacher) => {
    setSelectedTeacherId(teacher._id);
    setIsDetailModalOpen(true);
  };

  return (
    <>
      <GenericUserList
        fetchUsers={fetchTeachers}
        updateUser={updateTeacher}
        onView={handleView}
        userType="Teacher"
        columns={columns}
      />
      <TeacherDetailModal
        isOpen={isDetailModalOpen}
        onClose={() => setIsDetailModalOpen(false)}
        teacherId={selectedTeacherId}
      />
    </>
  );
};

export default TeacherList;
